import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { AvailabilityStatus } from '../flex-workers-for-work.types';

export function useAvailabilityStatusAndColor(availabilityState: string) {
  const theme = useTheme();
  const { t } = useTranslation('web-common');

  switch (availabilityState) {
    case AvailabilityStatus.CONDITIONAL:
      return {
        availability: t('fw_availability.conditional'),
        color: theme.palette.lwBlack[6],
      };
    case AvailabilityStatus.UNAVAILABLE:
      return { availability: t('fw_availability.unavailable'), color: theme.palette.lwDanger[20] };
    case AvailabilityStatus.AVAILABLE:
      return {
        availability: t('fw_availability.available'),
        color: theme.palette.lwPrimaryAccentLight[40],
      };
    default:
      return { availability: availabilityState, color: 'black' };
  }
}

const MONTHS_IN_YEAR = 12;

export function convertToExperienceFormat(months: number | null | undefined): string {
  if (!months || months < 1) {
    return '-';
  } else if (months < MONTHS_IN_YEAR) {
    return `${months} mnd`;
  } else {
    const monthPart = months % MONTHS_IN_YEAR ? ` ${months % MONTHS_IN_YEAR} mnd` : '';
    return `${Math.floor(months / MONTHS_IN_YEAR)} jr${monthPart}`;
  }
}
